export interface InitAiSpecificationTaskRequest {
    /** 任务ID */
    task_id: string;
    /** 用户输入的权利要求文本 */
    claim: string;
    /** 用户输入的交底书文本 */
    disclosure: string;
    /** 受理局 USPTO/CNIPA/EPO */
    jurisdiction: string;
}

export interface InitAiSpecificationTaskResponse {
}

export const InitAiSpecificationTaskApi = Symbol.for('InitAiSpecificationTaskApi');

export interface InitAiSpecificationTaskApi {
    initAiSpecificationTask(data: InitAiSpecificationTaskRequest): Promise<InitAiSpecificationTaskResponse>;
}
